<ng-container *transloco="let t">
    <div class="text-center">
        <tui-svg src="/assets/icons/locate.svg" class="!w-60 !h-60" size="full"></tui-svg>
    </div>

    <article class="prose">
        <h2 class="leading-6">
            {{ t('allow_access_to_the_location_of_the_device') }}
        </h2>
        <p>
            {{
                t('we_need_to_access_the_location_of_the_device_to_best_serve_you_in_the_process_of_using_the_service')
            }}
        </p>
    </article>

    <div class="grid grid-cols-2 gap-2 mt-4">
        <button tuiButton appearance="secondary" class="w-full" size="m" (click)="close(false)">
            {{ t('skip') }}
        </button>

        <button tuiButton appearance="primary" class="w-full" size="m" (click)="close(true)">
            {{ t('accept') }}
        </button>
    </div>
</ng-container>
